export default "__VITE_ASSET__D5E6We9v__"